import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'notify',
    templateUrl: './notify.component.html',
    styleUrls: ['./notify.component.scss'],
})
export class NotifyComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}

    public options = {
        position: ['top', 'right'],
        timeOut: 5000,
        lastOnBottom: true,
    };
}
